export default __webpack_public_path__ + "static/step3-5377516e7fb4b7292d64f49b9c206e68.png";